<template>
  <!--个人主页信息循环-->
  <div>
    <div v-for="(item,index) in userPapers" :key="index" class="userPaperBox">
     <div class="paperBox1">
       <div class="paperBoxTop">
         <router-link :to="{ name: 'quanItem', params: { paperid: item.paperid  },query:{thumbOpenid:openID}}" class="userNameWrapper">
           <div class='timeWrapper'><!--span class='userNameStyle orange '>晒单</span><span class='userNameStyle purple '>晒单</span--><span class='userNameStyle blue '>晒单</span>{{item.createtime}}
           </div>
         </router-link>
         <div class="share_btn_wrapper">
             <div class='share_btn' @click="muneShow(index)">
               <span class='circle'></span>
               <span class='circle'></span>
               <span class='circle'></span>
             </div>
           <div class="deleteWrapper" v-if="item.menuOpen">
             <div class='triangle_out'>
               <div class='triangle_in'></div>
             </div>
             <div class="deleteContentWrapper">
             <div class='deleteBtnWrapper'  @click='MessageBoxShow(index,item.paperid)'>
                 <span class="deleteFunction">评论</span>
               </div>
               <div class='deleteBtnWrapper' @click="deletePaper(item.paperid,item.senderopenid,index)">
                 <span class="deleteFunction">删除</span>
               </div>
                 <div class='deleteBtnWrapper' @click="muneShow(index)">
                   <span>取消</span>
                 </div>
             </div>
           </div>
         </div>
       </div>
       <router-link :to="{ name: 'quanItem', params: { paperid: item.paperid  },query:{thumbOpenid:openID}}" class="cotent">{{item.content}}
       </router-link>
       <div class="picsBox">
         <div v-for="(pic,index1) in item.pics"  class="picItem" >
           <img :src="gobalUrl+pic" class="pic"   @click="picView(index,index1)"/>
         </div>
         <div class="total" v-if="item.pics&&item.pics.length>3">共{{item.pics.length}}张</div>
       </div>
       <div class="welWrapper">
         <div v-if="item.welfareid" >
           <span class=" icon-gift icon_duihuan_color"></span>
           <span class="welText">福利</span>
         </div>
         <div>
           <span class="icon-ticket icon_ticket_color"></span>
           <!--span class="icon-gift icon_ticket_color"></span-->
           <span class="welText">优惠券</span>
         </div>
       </div>
     </div>
     <router-link :to="{ name: 'quanItem', params: { paperid: item.paperid  },query:{thumbOpenid:openID}}" class="paperMunesWrapper">
       <div class="paperMuneBtn">
         <span class="paperMuneIcon icon-share2"></span>
         <span class="paperMuneText">分享</span>
       </div>
       <div class="paperMuneBtn">
         <span class="paperMuneIcon icon-news2"></span>
         <span class="paperMuneText">{{item.discussCount}}</span>
       </div>
       <div class="paperMuneBtn">
         <span class="paperMuneIcon icon-love " :class="item.thumbOpenid!=null?'good':''"></span>
         <span class="paperMuneText">{{item.thumbCount}}</span>
       </div>
     </router-link>
   </div>
   <!-- Root element of PhotoSwipe. Must have class pswp. -->
   <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

       <!-- Background of PhotoSwipe.
            It's a separate element, as animating opacity is faster than rgba(). -->
       <div class="pswp__bg"></div>

       <!-- Slides wrapper with overflow:hidden. -->
       <div class="pswp__scroll-wrap">

           <!-- Container that holds slides. PhotoSwipe keeps only 3 slides in DOM to save memory. -->
           <div class="pswp__container">
               <!-- don't modify these 3 pswp__item elements, data is added later on -->
               <div class="pswp__item"></div>
               <div class="pswp__item"></div>
               <div class="pswp__item"></div>
           </div>

           <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
           <div class="pswp__ui pswp__ui--hidden">

               <div class="pswp__top-bar">

                   <!--  Controls are self-explanatory. Order can be changed. -->

                   <div class="pswp__counter"></div>

                   <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                   <button class="pswp__button pswp__button--share" title="Share"></button>

                   <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                   <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                   <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                   <!-- element will get class pswp__preloader--active when preloader is running -->
                   <div class="pswp__preloader">
                       <div class="pswp__preloader__icn">
                         <div class="pswp__preloader__cut">
                           <div class="pswp__preloader__donut"></div>
                         </div>
                       </div>
                   </div>
               </div>

               <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                   <div class="pswp__share-tooltip"></div>
               </div>

               <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
               </button>

               <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
               </button>

               <div class="pswp__caption">
                   <div class="pswp__caption__center"></div>
               </div>

             </div>

           </div>

   </div>
   <message @click.native="messageBoxHide()" :openID = "openID" :paperID='paperid' v-if="MessageBoxDisplay" :getDiscuss="getDiscuss"></message>
  </div>
</template>
<script type = "text/ecamscript-6">
import {getDateDiff,config} from  '../../common/js/common.js'//导入全局配置基础网址
import photoswipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
//导入组建
import Message from '@/components/quan/message'
import {
  Indicator,
  Toast,
  MessageBox
} from 'mint-ui' //提示加载更多
export default {
  'name':'userPaper',
  data(){
    return{
      openid:this.$route.params.openid,//获取id
      gobalUrl : config.gobalUrl,
      page:1,
      pageSize:10,
      userPapers:[],
      REQUIRE:false,
      openID:JSON.parse(sessionStorage.userInfo).openId,
      menuOpen:false,
      MessageBoxDisplay:false,
      discussIndex:''
    }
  },
  created () {
    this.login()
  },
  methods:{
    /*axios调用主页头部*/
     login () {
       this.url = "api/getPapers.php?openid="+this.openid+"&page="+this.page+"&pageSize="+this.pageSize+"&thumbOpenid="+this.openID
      //  console.log(this.url)
       this.$ajax.autoService
           .login(this.url)
           .then((res) => {
             //console.log(res)
             this.userPapers= this.userPapers.concat(res.data.map(function(item){
               item.createtime = getDateDiff(new Date(item.createtime.replace(/-/g, '/')));
            if (item.picUrls && item.picUrls != '') {
              item.pics = item.picUrls.split(',')
            }
            item.menuOpen = false
               return item
             }))
             this.$nextTick(() => {
               this.REQUIRE = true;
               if(res.data.length==0){
                 this.REQUIRE = false;
               }
             });
           }, (res) => {
               console.log("error")
           })
      },
      /*axios向下加载*/
      scrollBottom() {
       // 滚动到页面底部时，请求前一天的文章内容
       var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
       if (((window.screen.height + scrollTop) > (document.body.clientHeight))-10 && this.REQUIRE) {
         // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据

         this.REQUIRE = false;
         this.tips = '努力加载中...';
         this.page+=1
         this.login(this.url)

   }
 },
 picView (prama1,prama2) {
   var pswpElement = document.querySelectorAll('.pswp')[0];
   var picIndex = 0,
   items=[],
   item;
   for (var x in this.userPapers){
     picIndex++;
     if(picIndex-1 == prama1){
       for(var i=0;i<this.userPapers[x].pics.length;i++){
         var img = new Image();
         var picSrc,picWidth,picHeight;
         picSrc = this.gobalUrl+this.userPapers[x].pics[i] ;
         img.src = picSrc;
         picWidth = img.width;
         picHeight= img.height;
         item = {
           src:this.gobalUrl+this.userPapers[x].pics[i],
           w: picWidth,
           h: picHeight
         }
         items.push(item)
       }
     }
   }

var options = {
  index: prama2 ,// start at first slide
  galleryUID:prama1
};

var gallery = new photoswipe( pswpElement, PhotoSwipeUI_Default, items, options);
gallery.init();
},
getDiscuss(doType,page,pageSize) {
  this.$ajax.autoService.
  login("api/getDiscuss.php?paperid="+this.paperid+"&page="+page+"&pageSize="+pageSize).then((res)=>{
    //console.log(res.data)
    this.discuss = res.data.map(function (item) {
        item.menuShow = false
        return item
      })
    this.userPapers[this.discussIndex].discussCount =this.userPapers[this.discussIndex].discussCount*1+doType*1
    this.$forceUpdate();
    //console.log(this.userPapers)
  })
},
deletePaper(paperid,senderid,index){
  MessageBox.confirm('是否确认删除?').then(action => {
    if(action=="confirm"){
      this.$ajax.autoService.
      login("api/deletePaper.php?senderopenid="+senderid+"&paperid="+paperid).then((res)=>{
        this.userPapers.splice(index, 1)
        Toast({
          message:"删除成功"
        })
      })
    }
});
},
MessageBoxShow(doShowMenuIndex,paperid){//显示评论框
  this.muneShow(doShowMenuIndex)
  this.MessageBoxDisplay = true;
  this.paperid = paperid;
  this.discussIndex = doShowMenuIndex


},
messageBoxHide(){


  if(this.MessageBoxDisplay==true){
    this.MessageBoxDisplay=false
  }
},
muneShow(doShowMenuIndex) {//展开菜单
  this.userPapers[doShowMenuIndex].menuOpen = !this.userPapers[doShowMenuIndex].menuOpen
  this.$forceUpdate();

},
},
components:{
  'message':Message
},
mounted () {
   window.addEventListener('scroll', this.scrollBottom)

},
beforeDestroy(){
  window.onscroll = ""
}
}
</script>
<style lang="stylus">
  .userPaperBox
    width: 100%
    box-sizing: border-box
    padding: 30px 0 0
    margin-top: 25px
    background: #fff
    .paperBox1
      padding:0 30px
      .paperBoxTop
        display: flex
        position: relative
        z-index: 4
        line-height: 40px
        .userNameWrapper
          flex: 1
          box-sizing: border-box
          padding-top: 5px
          .timeWrapper
            font-size: 24px
            color: #999
            .userNameStyle
              height: 40px
              padding: 0 15px
              font-size:24px
              border-radius: 10px
              display: inline-block
              margin-right: 10px
              &.orange
                border: 1px solid #ff6e25
                /*px*/
                color: #ff6e25;
              &.purple
                border: 1px solid #d4adfb
                /*px*/
                color: #d4adfb
              &.blue
                border: 1px solid #1ecb94
                /*px*/
                color: #1ecb94
        .share_btn_wrapper
          flex: 0 0 100px;
          position: relative
          box-sizing:border-box
          .share_btn
            width: 50px
            height: 40px
            line-height: 40px
            font-size:0px
            padding-left:50px
            .circle
              display: inline-block
              width: 6px
              height: 6px
              border-radius: 3px
              background: #aaa
              vertical-align: middle
              margin:0 3px
          .deleteWrapper
            width: 198px
            position: absolute
            right: -20px
            top:70px
            box-sizing: border-box
            box-shadow: 0 0 5px #eee
            border: 1px solid #e5e5e5
            background: #fff
            .triangle_out
              width: 36px
              height: 14px
              position: absolute
              top: -13px
              right: 35px
              overflow: hidden
              z-index: 10
              .triangle_in
                width: 20px
                height: 20px
                background: #fff
                transform: rotate(45deg)
                position: absolute
                left: 8px
                top: 6px
                box-shadow: 0 0 5px #eee
                border: 1px solid #e5e5e5
                /*px*/
            .deleteBtnWrapper
              font-size: 28px
              color: #666
              text-align: center
              line-height: 80px
              border-bottom: 1px solid #e5e5e5
              /*px*/
              &:last-child
                border-bottom: 0px solid #e5e5e5
      .cotent
        font-size: 30px
        color: #333
        line-height: 42px
        margin-top:20px
      .picsBox
        display: flex
        overflow: hidden
        margin-top: 15px
        position: relative
        .picItem
          width: 224px
          height: 224px
          flex: 0 0 224px
          margin-right: 10px
          margin-bottom: 20px
          .pic
            width: 224px
            height: 224px
        .total
          position: absolute
          right: 0px
          top: 0px
          background: rgba(0, 0, 0, 0.7)
          width: 80px
          height: 42px
          text-align: center
          line-height: 42px
          color: #fff
          font-size: 24px
      .welWrapper
        line-height: 40px
        display: flex
        .icon_duihuan_color
          color: #ffad41
          font-size: 28px
        .welText
          font-size: 24px
          color: #999
          vertical-align: middle
          margin: 0 35px 0 10px
        .icon_ticket_color
          color: #f60
          font-size: 28px
          vertical-align: middle
    .paperMunesWrapper
      border-top: 1px solid #e5e5e5
      margin-top: 15px
      padding: 0 30px
      box-sizing: border-box
      display: flex
      .paperMuneBtn
        flex: 1
        height: 80px
        line-height: 80px
        text-align:center
        .paperMuneIcon
          font-size: 32px
          color: #666
          vertical-align: middle
          margin-right: 10px
          .paperMuneText
            font-size: 28px
            color: #333
            vertical-align: middle
  .mint-msgbox-title
    font-size:30px
  .mint-msgbox-message
    font-size:28px
  .mint-msgbox-btns
    height:80px
    line-height:80px
    .mint-msgbox-btn
      font-size:28px
</style>



// WEBPACK FOOTER //
// src/components/quan/userPaper.vue